import { isDefined, isNotDefined, isString, getResolution } from '../../utils/util';
import { BREAKPOINTS } from '../../model/model';

class SpecialBanner {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      global: window,
      data: null
    }, options);

    _.global = (_.option.global) ? _.option.global : window;

    _.wrap = null;
    _.handler = null;

    _.slickWrap = null;
    _.slickWrapOuterHtml = null;
    _.youtubeModal = null;

    _.currentResolution = '';
  }

  init() {
    const _ = this;
    // console.log('# SpecialBanner.js init() _.option : ', _.option);

    _.wrap = $(_.option.wrap);

    if (!_.wrap || _.wrap.length <= 0) return _;
    if (!_.option.data.visible) return _;
    _.currentResolution = getResolution(_.option.breakpoint, _.global);
    // console.log('# SpecialBanner.js init() _.option.data : ', _.option.data);

    let tmpl_item = _.option.data.items.map( (item, i) => {
      return `
        <li class="${item.contentsType}">
        <a href="${item.url}" class="${item.target}" data-youtube-id="${item.youtubeId}">
          <div class="contents">
          <div class="contents-img"><img src="${item.thumbnail}"></div>
          <strong>${item.title}</strong>
          <p>${item.desc}</p>
          </div>
        </a>
      </li>
      `;
    }).join('');

    let itemsSize = _.option.data.items.length;
    let tmpl = `
      <section class="section-special ${_.option.data.headerType}" data-bg="${_.option.data.bg}">
        <header>
          <h2>${_.option.data.header}</h2>
          <p>${_.option.data.headerdesc}</p>
        </header>
        <a class="btn-play" href="#" data-youtube-id="${_.option.data.youtubeId}">play</a>
        <ul class="special-type special-size-${itemsSize}">
            ${tmpl_item}        
        </ul>
      </section>
    `;

    _.option.wrap.empty().append(tmpl);

    _.handler = $('.section-special', _.option.wrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setWrapBg(); // _.setWrapBg(_.currentResolution);

    console.log('# setInstance() : _.handler', _.handler);

    if (_.handler.hasClass('image')) {
      _.setImageBanner();

    } else if (_.handler.hasClass('video')) {
      _.setVideoBanner();
    }

    $(_.global).on('resize', $.proxy(_.resize, _));

    _.resize();
  }

  setWrapBg() {
    const _ = this;

    let imgUrl = _.handler.attr('data-bg') || '';

    _.handler.css({'background-image': `url(${imgUrl})`});
  }

  /*
   setWrapBg(resolution) {
   const _ = this;

   let imgUrl = '';
   if (isMobileResolution(resolution)) {
   imgUrl = _.wrap.attr('data-bg-mobile');

   } else {
   imgUrl = _.wrap.attr('data-bg-pc');
   }

   _.wrap.css({'background-image': `url(${imgUrl})`});
   }
   */

  setImageBanner() {
    const _ = this;

    _.slickWrap = $('ul', _.handler);

      const listItems = $('li', _.slickWrap);
      _.slickWrap.addClass('special-size-' + listItems.length);

    _.slickWrapOuterHtml = _.slickWrap.clone().wrapAll('<div />').parent().html();

    if (listItems.length > _.getMaxNumListItems()) {
      // number of list can't exceed 4.
      return;
    }
    _.slickWrap.addClass('special-size-' + listItems.length);

    _.setSlickImageBanner();

    _.setImageBannerMouseEventHandler(true);
  }

  setSlickImageBanner() {
    const _ = this;

    _.slickWrap = $('ul', _.handler);

    _.slickWrap.slick({
      infinite: true,
      dots: true,
      speed: 250,

      responsive: [{
        breakpoint: BREAKPOINTS.max,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: BREAKPOINTS.pc,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, {
        breakpoint: BREAKPOINTS.tablet,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  }

  setImageBannerMouseEventHandler(flag) {
    const _ = this;

    $(_.handler).on('click', '.video a', function (evt) {
      event.preventDefault();

      const youtubeId = $(this).attr('data-youtube-id') || '';
      if (!isString(youtubeId) || youtubeId.trim() === '') {
        // require 'data-youtube-id' value.
        return;
      }

      if (isNotDefined(_.youtubeModal)) {
        _.youtubeModal = _.getYoutubeModal(youtubeId.trim());

      } else {
        _.youtubeModal.changeYoutubeIFrame(youtubeId);
      }

      _.youtubeModal.show();
    });
  }

  setVideoBanner() {
    const _ = this;

    $('.btn-play', _.handler).on('click', function (evt) {
      evt.preventDefault();

      const youtubeId = $(this).attr('data-youtube-id') || '';
      if (!isString(youtubeId) || youtubeId.trim() === '') {
        // require 'data-youtube-id' value.
        return;
      }

      if (!_.youtubeModal) _.youtubeModal = _.getYoutubeModal(youtubeId.trim());
      _.youtubeModal.show();
    });
  }

  resize(evt) {
    const _ = this,
      resolution = getResolution(_.option.breakpoint, _.global),
      breakpoint = _.option.breakpoint;

    if (breakpoint.max && _.global.innerWidth >= breakpoint.max) {
      _.destroySlickWrap();

    } else if (breakpoint.pc && _.global.innerWidth >= breakpoint.pc) {
      if (!_.isSlickWrapInitialized()) _.setSlickImageBanner();

    } else if (breakpoint.tablet && _.global.innerWidth >= breakpoint.tablet) {
      if (!_.isSlickWrapInitialized()) _.setSlickImageBanner();

    } else {
      if (!_.isSlickWrapInitialized()) _.setSlickImageBanner();
    }

    /*
     if (resolution !== _.currentResolution) {
     let isMobileRes = isMobileResolution(resolution),
     isCurrentMobileRes = isMobileResolution(_.currentResolution);

     if (isMobileRes && isCurrentMobileRes) {
     // change between phone and tablet

     } else if (!isMobileRes && !isCurrentMobileRes) {
     // change between pc and max

     } else {
     // console.log('change between phone/tablet and pc/max');

     _.setWrapBg(resolution);
     }
     }
     */

    _.currentResolution = resolution;
  }

  destroySlickWrap() {
    const _ = this;

    if (_.isSlickWrapInitialized()) {
      // destroy slick.
      _.slickWrap.slick('unslick');

      // reset slickWrap html.
      _.slickWrap.replaceWith(_.slickWrapOuterHtml);
    }
  }

  isSlickWrapInitialized() {
    const _ = this;

    if (_.slickWrap && _.slickWrap.length) return _.slickWrap.hasClass('slick-initialized');

    return false;
  }

  getYoutubeModal(youtubeId) {
    let youtubeModal = null;

    if (isDefined(nc.lineage.youtubeModal)) {
      youtubeModal = nc.lineage.youtubeModal({
        youtube: {id: youtubeId}
      });
    }

    return youtubeModal;
  }

  getMaxNumListItems() {
    return 4;
  }
}

export default SpecialBanner;


// WEBPACK FOOTER //
// ./_src/js/main/specialBanner/SpecialBanner.js